import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'viasverdes/pdf';
const CONTEXT_BASE_HTML_PATH = 'viasverdes/html';
const CONTEXT_SINGLE_BASE_PATH = 'viasverdes/pdfindividual';
// #endregion

// #region Public functions
async function getGreenWayPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchGreenWayPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchGreenWayHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getGreenWayPdf,
  searchGreenWayPdf,
  searchGreenWayHtml,
};
